// extracted by mini-css-extract-plugin
module.exports = {"header":"ContentWrapper_header_21dQE","body":"ContentWrapper_body_34TEx","breadcrumbs":"ContentWrapper_breadcrumbs_38eJt"};